module.exports = __webpack_public_path__ + "img/company.544e09ab.svg";